<template>
  <form @submit.prevent="onSubmit">
    <base-alert text="password_rule" type="info" class="text-sm" />
    <!-- Errors -->
    <FormError :errors="errors" />

    <!-- Form -->
    <div class="py-3 xl:py-4 xl:flex items-center border-b">
      <span class="xl:w-1/2 leading-5">{{ $t('mygwf.components.Form.current_password') }}:</span>
      <base-input-password
        class="mmt-3 leading-5 sm:mt-2 sm:col-span-2 space-x-4 w-full relative pb-2 lg:pb-3"
        v-model="form.current_password"
        focused
      />
    </div>
    <div class="py-3 xl:py-4 xl:flex items-center border-b">
      <span class="xl:w-1/2 leading-5">{{ $t('mygwf.components.Form.new_password') }}:</span>
      <base-input-password
        class="mt-3 leading-5 sm:mt-2 sm:col-span-2 space-x-4 w-full relative pb-2 lg:pb-3"
        v-model="form.new_password"
      />
    </div>
    <div class="py-3 xl:py-4 xl:flex items-center">
      <span class="xl:w-1/2 leading-5">{{ $t('mygwf.components.Form.re_new_password') }}:</span>
      <base-input-password
        class="mt-3 leading-5 sm:mt-2 sm:col-span-2 space-x-4 w-full relative pb-2 lg:pb-3"
        v-model="form.renew_password"
      />
    </div>

    <!-- Action buttons -->
    <div class="flex justify-end space-x-3 pt-5 my-1 border-t">
      <span class="self-center mr-auto">{{ requiredAllFieldsText }}</span>
      <base-button @click="$emit('close')" action="close" context="secondary">
        <base-icon icon="close" />
      </base-button>
      <base-button
        type="submit"
        action="save"
        :loading="pendingRequest"
        :disabled="$v.form.$invalid"
      >
        <base-icon icon="success" />
      </base-button>
    </div>
  </form>
</template>

<script>
import {BaseAlert, BaseInputPassword, BaseButton, BaseIcon} from '@/components/base'
import FormError from '@/components/shared/FormError'
import {required, minLength, sameAs, helpers} from 'vuelidate/lib/validators'

const _passwordValidator = helpers.regex('password', /^(?=.*\d)(?=.*[a-zA-Z])(?!.*\s).{8,}$/)

export default {
  components: {
    BaseAlert,
    FormError,
    BaseButton,
    BaseIcon,
    BaseInputPassword,
  },

  data() {
    return {
      pendingRequest: false,
      errors: {},
      form: {
        current_password: '',
        new_password: '',
        renew_password: '',
      },
    }
  },

  computed: {
    requiredAllFieldsText() {
      return this.$t('mygwf.components.Form.requiredAllFields')
    },
  },

  methods: {
    // ================================================================================
    // Events
    // ================================================================================

    async onSubmit() {
      if (this.pendingRequest || this.$v.form.$invalid) {
        return
      }

      try {
        this.pendingRequest = true
        this.errors = {}
        await this.$store.dispatch('profile/changePassword', this.form)
        this.$emit('changed')
        this.$store.dispatch('app/notification', {type: 'success', group: 'app', text: 'updated'})
      } catch (errors) {
        this.errors = errors
        this.$store.dispatch('app/notification', {type: 'error', group: 'app', text: 'updated'})
      } finally {
        this.pendingRequest = false
      }
    },
  },

  // ================================================================================
  // Validation
  // ================================================================================
  validations: {
    form: {
      current_password: {required, minLength: minLength(8)},
      new_password: {required, _passwordValidator},
      renew_password: {required, sameAs: sameAs('new_password')},
    },
  },
}
</script>
